import { useEffect } from "react";

export const useTimeoutEffect = (callback, delay, dependencies = []) => {
  useEffect(() => {
    const handler = setTimeout(() => {
      callback();
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, dependencies);
};
